export const formatMMMddyyyy = d =>
  new Date(d)
    .toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' })
    .replace(',', '');

export const formatMMMddyyyyHHmm = d => {
  const date = new Date(d);
  // Example: Jan 05, 2025 14:37
  const datePart = date
    .toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' })
    .replace(',', '');
  const timePart = date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: false });
  return `${datePart} ${timePart}`;
};
